<template>
    <div class="follow">
        <div class="card">
            <div class="title">
                <img src="https://appd.knowbox.cn/ss/activity/group-buy/buy-success-icon.png" alt="">
                <span>恭喜你，拼团成功</span>
            </div>
            <p class="txt_1">还差一步，就可以完成开课准备</p>
            <img src="https://appd.knowbox.cn/ss/activity/group-buy/ele.png" alt="">
            <div class="QR_code">
              <img src="https://appd.knowbox.cn/ss/activity/group-buy/QR_code.jpg" alt="">
            </div>
            <p class="txt_2">优质课程资源尽在眼前</p>
            <p class="txt_3"><span></span> 长按扫码关注服务号 <span></span></p>            
        </div>
    </div>
</template>

<script>
export default {
  name: "follow",
  components: {},
  created: function() {
    this.$wxShare({
      title: localStorage.getItem("shareTitle"),
      desc: localStorage.getItem("shareDesc"),
      link:
        window.location.origin +
        window.location.pathname +
        "#/group_buy/h5_detail?" +
        "groupInfoId=" +
        this.groupInfoId +
        "&groupId=" +
        this.groupId + '&pageChannel=' + localStorage.getItem('pageChannel'),
      imgUrl: localStorage.getItem("shareImgUrl")
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.follow {
  width: 100%;
  height: 100vh;
  background: #d4edff;
  overflow: hidden;
  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.3rem;
    width: calc(100% - 0.3rem * 2);
    height: calc(100% - 0.3rem * 2);
    background-color: #ffffff;
    border-radius: 0.2rem;
    .title {
      margin-top: 0.77rem;
      display: flex;
      align-items: center;
      font-weight: bolder;
      img {
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.17rem;
      }
      span {
        font-family: FZY4JW--GB1-0;
        font-size: 0.44rem;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #75c9ff;
      }
    }
    .QR_code {
      width: 2.7rem;
      height: 2.7rem;
      padding: 0.06rem;
      background-color: #ffffff;
      border-radius: 0.12rem;
      border: solid 0.02rem #eceef0;
      margin-top: -0.16rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .txt_1 {
      margin-top: 0.33rem;
      font-family: PingFangSC-Medium;
      font-size: 0.28rem;
      line-height: 0.28rem;
      height: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #919294;
    }
    .txt_2 {
      font-family: PingFangSC-Medium;
      font-size: 0.34rem;
      line-height: 0.34rem;
      height: 0.34rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #7c7e80;
      margin-top: 0.38rem;
    }
    .txt_3 {
      margin-top: 0.17rem;
      font-family: PingFangSC-Regular;
      font-size: 0.26rem;
      line-height: 0.26rem;
      height: 0.26rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #919294;
      span {
        background: #dcdde0;
        width: .12rem;
        height: .03rem;
        border-radius: .03rem;
        display: inline-block;
        margin-bottom: 0.08rem;
      }
    }
    > img {
      width: 2.37rem;
      height: 1.91rem;
      margin-top: 1.04rem;
    }
  }
}
</style>